<template>
    <a-spin :spinning="spinning" tip="Loading...">
        <div class="card mb-3">
            <div class="row no-gutters">
                <div class="col-md-12" style="border-right: 1px solid #e0e0e0">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-4">
                                <base-input alternative="" label="Select Wavelet">
                                    <a-select v-model="inputWavelet" showSearch allowClear mode="multiple" placeholder="All Wavelets" optionFilterProp="children" style="width: 100%" :filterOption="filterOption">
                                        <a-select-option v-for="option in waveletOptions" :key="option.id" :value="option.id">
                                            {{option.name}}
                                        </a-select-option>
                                    </a-select>
                                </base-input>
                            </div>
                        </div>

                        <div class="row mt-3">
                            <div class="col-md-12">
                                <button class="btn btn-sm btn-success float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateExcel">
                                    Generate Report in Excel
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </a-spin>
</template>

<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import secureStorage from '../../controllers/secureStorage';
    import reportUtils from '../../components/reportUtils'
    import moment from 'moment';
    import * as ExcelJS from "exceljs";
    import { saveAs } from "file-saver";
    import _ from 'lodash';

    import {
        mapState,
        mapActions
    } from 'vuex'

    var component_x;

    export default {
        data() {
            return {
                spinning: false,
                inputWavelet: [],
                waveletOptions: [],
                reportData: [],
            }
        },
        mounted: async function () {
        component_x = this;
            // Load wavelets
            var wavelets = await HTTPRequest.getRequest(component_x.endPoint + "wavelets/owned", null);
            component_x.waveletOptions = wavelets;
            component_x.sort(component_x.waveletOptions);
        },
        computed: {
            ...mapState(['currentProfile', 'endPoint']),
        },
        methods: {
            moment,
            filterOption(input, option) {
                return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            },
            sort(data) {
                data.sort(function (a, b) {
                return a.name.localeCompare(b.name);
                });
            },
            async generateExcel() {
                this.spinning = true;
                this.reportData = [];

                let parameters = {
                    "wavelet_id": this.inputWavelet.toString()
                };

                try {
                    const response = await HTTPRequest.getRequest(this.endPoint + 'wavelet_access_reports?', parameters);

                    if (response.error) {
                        reportUtils.openNotificationWithIcon(this, 'error', response.error);
                        this.spinning = false;
                        return;
                    }

                    if (response.length > 0 && response[0].report_details.length > 0) {
                        this.reportData = response[0].report_details;
                        await this.createExcelReport();
                    } else {
                        reportUtils.openNotificationWithIcon(this, 'warning', 'No Data.');
                    }
                } catch (error) {
                    reportUtils.openNotificationWithIcon(this, 'error', 'An error occurred while generating the report.');
                    console.error(error);
                }

                this.spinning = false;
            },
            getSelectedWaveletNames() {
                const names = new Set();
                this.inputWavelet.forEach(id => {
                    const found = this.reportData.find(r => r.wavelet_id === id);
                    if (found) names.add(found.wavelet_name);
                });
                return Array.from(names);
            },
            async createExcelReport() {
                const workbook = new ExcelJS.Workbook();
                workbook.created = new Date();
                workbook.modified = new Date();
                const sheet = workbook.addWorksheet("Wavelet Access Report", {
                    pageSetup: { paperSize: 9 }
                });

                // Header Rows
                const data_starts_at_row = 8;

                sheet.getRow(4).values = ["Wavelet Access Report"];
                sheet.getRow(5).values = [`Generated on: ${moment().format('MM/DD/YYYY hh:mm A')}`];
                sheet.getRow(6).values = [`Selected Wavelet(s): ${this.inputWavelet.length > 0 ? this.getSelectedWaveletNames().join(', ') : 'All Wavelets'}`];
                sheet.getRow(7).values = [`Generated by: ${secureStorage.getItem("email") || 'System'}`];

                sheet.getRow(data_starts_at_row).values = [
                    "Wavelet Name",
                    "Wavelet Access",
                    "Platform",
                ];

                sheet.columns = [
                    { key: "wavelet_name", width: 30 },
                    { key: "wavelet_access", width: 30 },
                    { key: "platform", width: 30 },
                ];

                this.reportData.forEach(item => {
                    sheet.addRow({
                        wavelet_name: item.wavelet_name,
                        wavelet_access: item.wavelet_access,
                        platform: item.platform,
                    });
                });

                // console.log("reportData", this.reportData);

                sheet.getRow(4).font = { bold: true, size: 16 };
                sheet.getRow(4).height = 20;
                sheet.getRow(data_starts_at_row).font = { bold: true };

                sheet.eachRow((row, rowNum) => {
                    if (rowNum >= data_starts_at_row) {
                        row.eachCell((cell, cellNum) => {
                            cell.alignment = rowNum === data_starts_at_row
                                ? { horizontal: 'center' }
                                : { vertical: 'middle', horizontal: 'left' };
                        });
                    }
                });

                workbook.xlsx.writeBuffer().then(buffer => {
                    const blob = new Blob([buffer], { type: "application/xlsx" });
                    saveAs(blob, `WaveletAccessReport.xlsx`);
                });
            }
        }
    };
</script>

<style>
.table th, .table td {
    vertical-align: middle;
}
</style>
